// extracted by mini-css-extract-plugin
export default {"create-manage":"create-manage-qr_create-manage__bWzOG"};